<template>
  <div class="insights-onboarding-completed">
    <h3 data-testid="insights-onboarding-complete-title">
      🎉 You have successfully completed Insights onboarding!
    </h3>
    <img
      :src="INSIGHTS_ONBOARDING_COMPLETED_IMG"
      alt="Insights Onboarding Completed"
      class="completed-image"
    />

    <AppButton
      type="primary"
      class="btn-primary"
      data-testid="insights-onboarding-complete-button"
      @click="redirectToInsights"
    >
      Take me to Insights
    </AppButton>
  </div>
</template>
<script>
import { INSIGHTS_ONBOARDING_COMPLETED_IMG } from '~/rails_assets';

export default {
  name: 'InsightsOnboardingCompleted',
  props: {
    organization: {
      type: Object,
      required: true,
    },
    completionScreenData: {
      type: Object,
      required: true,
      validate(value) {
        return value && typeof value.insights_path === 'string';
      },
    },
  },
  data() {
    return {
      INSIGHTS_ONBOARDING_COMPLETED_IMG,
    };
  },
  methods: {
    redirectToInsights() {
      window.location.href = this.completionScreenData.insights_path;
    },
  },
};
</script>
